export const appGroupIdPlaywrightScanA11y = "/:app_group_id/playwright/scan_a11y" as const;
